import { ReactNode, useEffect, useState } from "react";

import Alert, { AlertProps } from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { getDefaultSettings, saveDefaultSettings } from "src/api/settings";
import { SettingKey } from "src/shared/api-types/user";

interface HintProps {
  settingKey: SettingKey;
  children: ReactNode;
  severity?: AlertProps["severity"];
  sx?: AlertProps["sx"];
}

const Hint = ({ settingKey, children, severity = "info", sx }: HintProps) => {
  const [dismissed, setDismissed] = useState<boolean | null>(null);

  useEffect(() => {
    getDefaultSettings(settingKey).then((setting) => {
      setDismissed(setting?.value?.dismissed === true);
    });
  }, [settingKey]);

  const handleDismiss = () => {
    setDismissed(true);
    saveDefaultSettings(settingKey, { dismissed: true });
  };

  if (dismissed !== false) return null;

  return (
    <Alert
      severity={severity}
      sx={sx}
      action={
        <IconButton size="small" onClick={handleDismiss}>
          <CloseIcon fontSize="inherit" />
        </IconButton>
      }
    >
      {children}
    </Alert>
  );
};

export default Hint;
